module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-2-1-9520f9be256c2b8eb18829cd3ffd06bf.jpg";